import UmooveApi from "../../../components/api/UmooveApi";
import TitleRead from "../../../components/Common/TitleRead";
import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import mainContext from "../../../context/mainContext";
import Button from "../../../components/Common/Button";
import styles from "./style.module.css";
import dataContext from "../../../context/dataContext";
import userRequests from "../../../components/api/userRequests";

// Creator : Team A - Amos

function Comprehension() {
  const l = useLocation();
  const navigate = useNavigate();

  const {
    header: { setPageName, setIsShowHeader },
    nav: { setIsShowNav }
  } = useContext(mainContext);
  const { sumOfAssessments, setSumOfAssessments, serverData, examData, assessmentId, userDetails, setUserDetails } = useContext(dataContext)

  const [currentLine, setCurrentLine] = useState(0); // Current line index
  const [startToReadAt, setStartToReadAt] = useState(0)
  const imgRef = useRef(null); // Reference to the img element

  useEffect(() => {
    setPageName("comprehension");
    setIsShowHeader(false);
    setStartToReadAt(Date.now);
    setTimeout(() => {
      let nextIndex = checkForNextIndex(userDetails.assessmentsCurrIndex);
      userRequests.updateUserDetails({ assessmentsCurrIndex: nextIndex }, userDetails.id).then(newUserData => setUserDetails(prev => ({ ...prev, assessmentsCurrIndex: newUserData.assessmentsCurrIndex })))
    }, 5000)
    return () => setPageName("");
  }, []);

  const checkForNextIndex = (currIndex) => {
    let nextIndex = (!isNaN(currIndex) && currIndex) || currIndex === 0 ? Number(currIndex) + 1 : 0;
    if (nextIndex >= sumOfAssessments) {
      nextIndex = 0
    }
    return nextIndex
  }


  const nextPage = () => {
    console.log("clicked");
    let currentTime = Date.now();
    let totalReadingTime = currentTime - startToReadAt;
    let AvgNStd = UmooveApi.API_stopReading(examData); // Assuming this returns the time per line
    let WPMByTime = ((examData.words / totalReadingTime) * 1000 * 60).toFixed(2);
    if ((AvgNStd.mean == 170 && AvgNStd.std == 15) || AvgNStd.mean == null) {//TODO: it is mean that the eye tracking or calculation dosnt go well
      AvgNStd.mean = WPMByTime;
      if (AvgNStd.mean == null) {
        AvgNStd.std = 15;
      }
    }
    console.log("time per line 2", AvgNStd);
    AvgNStd.mean = Number(AvgNStd.mean);
    console.log("time per line", AvgNStd);
    userRequests.userDebugg(window.debuggarray, userDetails);
    // UmooveApi.API_stopUmoove();
    console.log({ exam: examData });
    navigate("/assessments/comprehension-Test", { state: { exam: examData, AvgNStd } });
  };

  useEffect(() => {
    window.debuggarray[0].umooveData = [];
    UmooveApi.API_startReading();
    return () => {
      UmooveApi.API_stopUmoove();
    };
  }, []);

  const handleLineRead = () => {
    setCurrentLine((prevLine) => prevLine + 1);
  };

  const handleTouchMove = (event) => {
    const { clientY } = event.touches[0]; // Get the vertical position of the touch
    const imgRect = imgRef.current.getBoundingClientRect();
    const lineHeight = imgRect.height / 23 /* number of lines */; // Calculate the height of each line

    const lineIndex = Math.floor((clientY - imgRect.top) / lineHeight); // Calculate the current line index
    console.log("🚀 ~ file: index.jsx:72 ~ handleTouchMove ~ lineIndex:", lineIndex)

    setCurrentLine(lineIndex);
  };

  return (
    <>
      <div className={styles.container}>
        {/* <div>
          <TitleRead />
        </div> */}
        <div className={styles.contentContainer}>


          <img
            className={styles.img}
            src={l.state.image}
            // src={`https://firebasestorage.googleapis.com/v0/b/readmateapp-696eb.appspot.com/o/tests_images%2F${examData.title}?alt=media`}
            alt="text"
            // onTouchMove={handleTouchMove} // Handle touch move event
            ref={imgRef}
            style={{ width: "100%" }}
          />


          <Button
            startFunction={() => {
              nextPage();
            }}
            title={"Done"}
            marginTop={0}
          />
        </div>
      </div>
    </>
  );
}

export default Comprehension;
